// Antera case studies - listing data
// Detail content for each study is stored in MongoDB (rich fields: subtitle,
// challenge, solution, results, quote, facts). This file is the read-time
// fallback so the listing renders even on a cold start.

const caseStudies = [
  {
    slug: "logotology",
    company: "Logotology",
    industry: "Multi-brand Promotional Products & Apparel",
    headline: "How Logotology scaled multi-brand production by 40%",
    excerpt:
      "Logotology unified Logotology, GolfTournament.com, and Classroom Apparel into a single Antera Advance command center - turning reactive firefighting into proactive planning.",
    image:
      "/api/media/a9941a96-ead7-56ad-a18b-ed6a8936ca41",
    metric: "+40%",
    metricLabel: "Manufacturing Output",
    published: true,
  },
  {
    slug: "beachley-medical",
    company: "Beachley Medical",
    industry: "Orthopedic Rehab & National PT Apparel",
    headline:
      "Empowering 900+ locations with automated procurement and 100% brand governance",
    excerpt:
      "A national physical therapy corporation with 9,000 employees uses Antera Aether + Advance to automate spend governance and lock in brand consistency across every site.",
    image:
      "/api/media/b99cd589-ddd4-45e6-816e-9c79562c9ab1",
    metric: "900+",
    metricLabel: "Locations Served",
    published: true,
  },
];

export default caseStudies;
